<template>
  <div>
    <v-card>
      <hotelListTable />
    </v-card>
  </div>
</template>

<script>
import hotelListTable from "@/components/back-office/HotelServices/HotelListTable.vue";

export default {
  components: {
    hotelListTable,
  },
};
</script>
